import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundPage } from '../pages/notfound/notfound.page';
import { ConfirmDataPage } from './pages/confirm-data/confirm-data.page';
import { FinishAccountPage } from './pages/finish-account/finish-account.page';
import { AccountMigrationLoginPage } from './pages/account-migration-login/account-migration-login.page';
import { Routes as RoutesKeys } from './routes';
import { OnboardingPage } from './pages/onboarding/onboarding.page';

const routes: Routes = [
  {
    path: RoutesKeys.LOGIN,
    component: AccountMigrationLoginPage,
  },
  {
    path: RoutesKeys.FINISH_ACCOUNT,
    component: FinishAccountPage,
  },
  {
    path: RoutesKeys.CONFIRM_DATA,
    component: ConfirmDataPage,
  },
  {
    path: RoutesKeys.ONBOARDING,
    component: OnboardingPage,
  },
  { path: '**', pathMatch: 'full', component: NotFoundPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
/**
 * Account Migration routing module
 */
export class AccountMigrationRoutingModule {}
